import { useContext, useEffect, useState } from 'react'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import QuestionnaireCanvas from '../v2/questionnaireCanvas'
import Questionnaire from '../../../../libs/api/services/Questionnaire'
import QuestionnaireAssignment from '../../../../libs/api/services/QuestionnaireAssignment'
import { QuestionnaireBuilderProvider } from '../builder/QuestionnaireBuilderProvider'
import QCaptureComponentNew from './components/QCaptureComponentNew'

export default function QCaptureEmbeded({ questionnaireId, QuestionnaireAssignmentId, className }) {
    // const { GlobalRef } = useContext(CommonFunctionsContext)
    // const [qaid, setQaid] = useState(QuestionnaireAssignmentId)
    // const [details, setDetails] = useState()


    // const loadDetails = async (QAID) => {
    //     const res = await Questionnaire
    //         .GetQuestionnaireResultsFull(QAID).catch(err => {
    //             console.error('Error loading questionnaire details:', err)
    //             return null
    //         })
    //     // console.log('loadDetails', res)
    //     setDetails(res)
    // }

    // useEffect(() => {

    //     const load = async () => {
    //         let newQUID
    //         if (QuestionnaireAssignmentId !== "New")/// Continue session
    //             newQUID = QuestionnaireAssignmentId
    //         else {
    //             // Current 
    //             // Check Cache 
    //             const QAID = localStorage.getItem("QAID")
    //             // Remove previous incomplete
    //             if (QAID != null) await QuestionnaireAssignment.RemoveColdRequest(questionnaireId, QAID).catch(err => {
    //                 console.error('Error removing cold request:', err)
    //             })
    //             // Start a new request
    //             const res = await QuestionnaireAssignment.NewColdRequest(questionnaireId).catch(err => {
    //                 console.error('Error creating new cold request:', err)
    //                 return null
    //             })
    //             if (!res) return
    //             newQUID = res.id
    //         }
    //         localStorage.setItem("QAID", newQUID)
    //         loadDetails(newQUID)
    //     }
    //     load()
    // }, [QuestionnaireAssignmentId, questionnaireId])


    // if(!details) return (
    //     <div>Loading...</div>
    // )

    // return (
    //     details && localStorage.getItem("QAID") != null &&
    //     <div ref={r => GlobalRef(r, 'LoginRegistrationForm')} className={'w-100 '.concat(className)}>
    //         <QuestionnaireBuilderProvider assignmentId={localStorage.getItem("QAID")}>
    //             <QCaptureComponentNew
    //                 view="New"
    //                 cachedDetails={details}
    //                 QuestionnaireAssignmentId={localStorage.getItem("QAID")}
    //                 QuestionnaireId={questionnaireId} />
    //         </QuestionnaireBuilderProvider>
    //     </div>
    // )
    return <QuestionnaireCanvas questionnaireId={'718389BF-E1D4-47A8-B660-1B8287E40611'} extra={{ anonymousAssignment: true }} />
}
// 718389BF-E1D4-47A8-B660-1B8287E40611